const steps = {
    DETAILS: 'Details',
    BUILD_CONTEXT: 'Build Context',
    CHOOSE_DSP: 'Choose DSP',
    ACTIVATE: 'Activate',
    SUMMARY: 'Summary',
};

export default steps;
